var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"terms-tabs transparent rounded-0",attrs:{"elevation":"0"}},[_c('ConditionOneTab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }